import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div aria-live="polite" class="toast-host">
      @for (message of toastService.messages(); track message.id) {
        <div class="toast toast--{{ message.variant }}" role="alert">
          <span class="toast__text">{{ message.text }}</span>
          @if (message.detail) {
            <span class="toast__detail">{{ message.detail }}</span>
          }
          <button type="button" class="toast__dismiss" aria-label="Dismiss" (click)="toastService.dismiss(message.id)">
            ×
          </button>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toast-host {
        position: fixed;
        bottom: 24px;
        right: 24px;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        gap: 8px;
        pointer-events: none;
      }

      .toast {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 12px 16px;
        border-radius: 8px;
        min-width: 280px;
        max-width: 400px;
        font-size: 0.875rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        pointer-events: auto;
      }

      .toast--success {
        background: #166534;
        color: #f0fdf4;
      }

      .toast--error {
        background: #991b1b;
        color: #fef2f2;
      }

      .toast--info {
        background: #1e40af;
        color: #eff6ff;
      }

      .toast__text {
        flex: 1;
        font-weight: 500;
      }

      .toast__detail {
        font-size: 0.8rem;
        opacity: 0.85;
      }

      .toast__dismiss {
        background: transparent;
        border: none;
        color: inherit;
        font-size: 1.25rem;
        cursor: pointer;
        padding: 0 4px;
        line-height: 1;
        opacity: 0.7;
      }

      .toast__dismiss:hover {
        opacity: 1;
      }
    `
  ]
})
export class ToastComponent {
  readonly toastService = inject(ToastService);
}